import { Icon, Spinner } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import { useVehicleManagementOwnerDriverDetailsQuery } from "generated/graphql"
import React from "react"
import { useNavigate } from "react-router-dom"
import { readableDate } from "utils/custom.utils"
import InfoRow, { InfoRowDivider } from "../InfoRow"

interface Props {
  vehicle: any
  ownerId: number | null
  type?: "driver" | "owner"
}
const Owner = ({ ownerId, type, vehicle }: Props) => {
  const navigate = useNavigate()
  const { data, loading, error } = useVehicleManagementOwnerDriverDetailsQuery({
    variables: { id: ownerId },
  })
  if (loading) return <Spinner />
  if (error) return <>{`${error.message}`}</>
  const owner = data?.userDetails
  const kyc = owner?.kycDetails?.[0]
  const bank = owner?.bankDetails?.[0]
  const licence = owner?.licenceDetails?.[0]
  //
  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-9">
        <InfoRow title="Name" subtitle={owner?.fullName} />
        <InfoRow title="Phone Number" subtitle={owner?.number} />
        <InfoRow
          title="Date Of Birth"
          subtitle={readableDate(owner?.dateOfBirth)}
        />
        <InfoRow title="Email" subtitle={owner?.email} />
        <InfoRow
          title="Address"
          subtitle={
            <span>
              <Icon icon="map-marker" /> {owner?.address?.village}
            </span>
          }
        />
        <InfoRowDivider className="my-4" title="KYC Details" />
        <InfoRow title="ID Number" subtitle={kyc?.idNumber} />
        <InfoRow title="Type" subtitle={kyc?.kycType.name} />
        <InfoRow
          title="Photo"
          subtitle={
            kyc?.photo ? (
              <a
                className="vt-styled-link vt-styled-link-text"
                href={kyc?.photo}
                target="__blank"
              >
                View Photo
              </a>
            ) : (
              "NA"
            )
          }
        />
        <InfoRowDivider className="my-4" title="Bank Details" />
        <InfoRow title="IFSC Code" subtitle={bank?.ifscCode ?? "NA"} />
        <InfoRow title="Account Number" subtitle={bank?.accountNumber ?? "0"} />
        <InfoRow title="Bank" subtitle={bank?.bank.name ?? "NA"} />

        <InfoRowDivider className="my-4" title="Licence Details" />
        <InfoRow title="Licence Number" subtitle={licence?.idNumber ?? "NA"} />
        <InfoRow title="Valid Till" subtitle={licence?.validTill ?? "NA"} />
      </div>
      <div className="col-span-3">
        <CustomButton
          icon="edit"
          text="Edit Details"
          onClick={e => {
            navigate(`/d/registration/${type}/${owner?.id}`, { state: vehicle })
          }}
        />
      </div>
    </div>
  )
}

export default Owner
